import { useQuery } from "react-query";
import { zodParseWithLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { z } from "zod";

export const getAllActionPlanKey = "getAllActionPlan" as const;

type Options = {
    queryParam?: AxiosParams;
};
export const useGetAllActionPlan = (options?: Options) => {
    const { queryParam = {} } = options || {};

    const paramKeysValue = Object.values(queryParam);
    const query = useQuery({
        queryKey: [getAllActionPlanKey, ...paramKeysValue],
        queryFn: async () => {
            const url = `/api/action_plans`;
            const response = await loggedInApiCall.get(url, {
                params: queryParam,
            });
            return response;
        },
        select: (resp) => {
            const data = resp.data["hydra:member"];
            const validatedData = zodParseWithLog(data, ActionPlanListSchema, getAllActionPlanKey);
            return validatedData;
        },
    });

    return query;
};

export const ActionPlanListSchema = z
    .object({
        "@id": z.string(),
        id: z.string(),
    })
    .array();
